export const combine = (...fns) => (...args) => fns.reduce((acc, fn) => ({
    ...acc,
    ...(fn(...args) || {}),
}), {})
